import { render } from "./ExecutionHistogramWidget.vue?vue&type=template&id=03e165fd&scoped=true"
import script from "./ExecutionHistogramWidget.vue?vue&type=script&lang=js"
export * from "./ExecutionHistogramWidget.vue?vue&type=script&lang=js"

import "./ExecutionHistogramWidget.vue?vue&type=style&index=0&id=03e165fd&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e165fd"]])

export default __exports__